var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showImage)?_c('div',{directives:[{name:"resize",rawName:"v-resize.initial",value:(_vm.handleResize),expression:"handleResize",modifiers:{"initial":true}}],staticClass:"hero-container"},[_vm._t("above"),_vm._v(" "),_c('img',{ref:"heroImage",staticClass:"no-highlight hero-image",attrs:{"src":_vm.imageUrl,"alt":_vm.altText},on:{"onLoad":_vm.loadImage,"onError":_vm.loadError}}),_vm._v(" "),_vm._t("below")],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3b9c0be","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseHeroImage.vue
// module id = null
// module chunks = 